import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Operario/imprimirOperarios`, method: 'POST', body: list, token: token})
}